export const TAB_BG_COLOR_DEFAULT = "var(--offwhite-color)";
export const TAB_SELECTION_COLOR_DEFAULT = "var(--darkest-purple)";
export const TAB_FONT_SIZE_DEFAULT = "1rem";
export const ROUNDED_CONTAINER_DEFAULT = true;
